<template>
  <div class="detail">
    <section class="product_detail_page">
      <div class="request_header hid">
        <div class="flx">
          <div class="back_arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="16"
              viewBox="0 0 20 16"
              @click="goBack()"
            >
              <g fill="#505050" fill-rule="evenodd">
                <path
                  fill="#505050"
                  fill-rule="nonzero"
                  stroke="#505050"
                  stroke-width="0.05"
                  d="M18.2 6.72c.591 0 1.07.501 1.07 1.12 0 .619-.479 1.12-1.07 1.12H1.07C.48 8.96 0 8.459 0 7.84c0-.619.48-1.12 1.07-1.12H18.2z"
                />
                <path
                  fill="#505050"
                  fill-rule="nonzero"
                  stroke="#505050"
                  stroke-width="0.05"
                  d="M2.585 7.84l5.666 5.928a1.157 1.157 0 0 1 0 1.584 1.038 1.038 0 0 1-1.514 0L.314 8.632a1.157 1.157 0 0 1 0-1.584L6.737.328a1.038 1.038 0 0 1 1.514 0 1.157 1.157 0 0 1 0 1.584L2.585 7.84z"
                />
              </g>
            </svg>
          </div>
          <div class="thumbimage_wrapper">
            <span class="thumbnail_image" v-if="allDetails.itemMediaDTOList">
              <img
                class="image__item"
                :src="allDetails.itemMediaDTOList[0].thumbnail"
                alt="random image"
              />
            </span>
          </div>
          <div class="icon_wrapper">
            <span
              class="tabIcon"
              :class="{'active' : isBookMark == false}"
              @click="bookMark(allDetails.saleReferenceID,isBookMark)"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17" viewBox="0 0 14 17">
                <path
                  fill="#505050"
                  fill-rule="evenodd"
                  d="M11.433 14.328V2.52a.829.829 0 0 0-.816-.84H2.45a.829.829 0 0 0-.817.84v11.808l4.426-3.252a.798.798 0 0 1 .949 0l4.425 3.252zm-4.9-1.536l-5.242 3.852c-.54.397-1.291 0-1.291-.684V2.52C0 1.128 1.097 0 2.45 0h8.167c1.353 0 2.45 1.128 2.45 2.52v13.44c0 .683-.751 1.08-1.292.684l-5.242-3.852z"
                />
              </svg>
            </span>
          </div>
        </div>

        <div class="sticky_detail_tab flx">
          <span class="detail_tab_name" @click="ChangeTab(1)" :class="getClass(1)">
            <a href="#div-detailtab" v-smooth-scroll="{updateHistory: false}">{{$t('productDetail')}}</a>
          </span>
          <span class="comment_tab_name" @click="ChangeTab(2)" :class="getClass(2)">
            <a
              href="#div-comment"
              v-smooth-scroll="{updateHistory: false}"
            >{{$t('comments')}}</a>
          </span>

          <span class="related_prdt_name" @click="ChangeTab(3)" :class="getClass(3)">
            <a
              href="#div-relatedprouct"
              v-smooth-scroll="{updateHistory: false}"
            >{{$t('relatedProduct')}}</a>
          </span>
        </div>
      </div>
      <ImageSlider :dataValue="allDetails" :viewerCount="viewCount" />
      <div>
        <ProductDetailTab
          :dataValue="allDetails"
          @ENABLACUTPRICE="ENABLACUTPRICE"
          :dataStyleAmount="finalPainAmountCut"
          id="div-detailtab"
        />
        <ProductDetailCommentTab
          :CmtDetails="commentList"
          :saleReferenceId="allDetails.saleReferenceID"
          id="div-comment"
        />
        <ProductCard
          :dataValue="recommendedProductList"
          :title="$t('relatedProduct')"
          :merchantId="categoryId"
          id="div-relatedprouct"
        />
      </div>
    </section>
    <div class="loader" v-if="loading">
      <img src="../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import "../assets/css/product-detail.scss";
import ImageSlider from "../components/ProductDetailSection/ImageSlider";
import ProductDetailTab from "../components/ProductDetailSection/ProductDetailTab";
import ProductDetailCommentTab from "../components/ProductDetailSection/ProductDetailCommentTab";
import ProductCard from "../components/HomeSection/ProductCard";
import vueSmoothScroll from "vue2-smooth-scroll";
import { mapGetters, mapState } from "vuex";
import Vue from "vue";
Vue.use(vueSmoothScroll);
export default {
  name: "ProductDetail",
  components: {
    ImageSlider,
    ProductDetailTab,
    ProductDetailCommentTab,
    ProductCard
  },

  data() {
    return {
      saleReferenceID: null,
      loading: false,
      details: [],
      allDetails: {},
      likeCount: 5,
      commentCount: 10,
      productDtlSpan: true,
      ProductDtlLikeSpan: false,
      ProductDtlCmntSpan: false,
      selectedFilterType: "",
      viewCount: "0",
      categoryId: 0,
      recommendedProductList: [],
      orderSourceType: null,
      finalPainAmountCut: false,
      isBookMark: true,
      commentList: [],
      commentIndex: 0,
      commentLimit: 10,
      thumbnailImage: false
    };
  },
  methods: {
    goBack() {
       if (this.$cookie.get("version-code") > 57) {
        if (window.history.length == 1) {
          try {
            JSBridgePlugin.gotToHome();
          } catch (err) {
            console.log(err);
          }
        } else {
          this.$router.go(-1);
        }
      } else {
        this.$router.go(-1);
      }
    },
    bookMark(productId, isBookMark) {
      var xauthid = this.$cookie.get("X-Auth-Id");
      try {
        if (this.isBookMark) {
          this.isBookMark = false;
        } else {
          this.isBookMark = true;
        }
        JSBridgePlugin.bookmarkProduct(Number(productId), isBookMark);
      } catch (err) {
        console.log(err);
      }
    },
    getClass(type) {
      if (this.selectedFilterType == type) {
        return "active";
      }
    },
    ChangeTab(value) {
      this.selectedFilterType = value;
      if (value == 1) {
        this.productDtlSpan = true;
        this.ProductDtlLikeSpan = false;
        this.ProductDtlCmntSpan = false;
      } else if (value == 2) {
        this.productDtlSpan = false;
        this.ProductDtlLikeSpan = true;
        this.ProductDtlCmntSpan = false;
      } else {
        this.productDtlSpan = false;
        this.ProductDtlLikeSpan = false;
        this.ProductDtlCmntSpan = true;
      }
    },
    ENABLACUTPRICE(cuttheprice_boolean) {
      this.getProductDetail(cuttheprice_boolean);
    },
    getProductDetail(cuttheprice_boolean) {
      this.$data.saleReferenceID = this.$route.params.saleReferenceID;
      this.loading = true;
      if (this.$route.query.source) {
        this.orderSourceType = this.$route.query.source;
      } else {
        this.orderSourceType = null;
      }
      const obj = {
        saleReferenceID: this.$route.params.saleReferenceID,
        referralUserId: this.$route.params.encodedId,
        orderSourceType: this.orderSourceType,
        cutPrice: cuttheprice_boolean
      };
      this.$store
        .dispatch({
          type: "getProductDetail",
          payload: obj
        })
        .then(data => {
          this.loading = false;
          this.allDetails = data.data;
          this.details = data.data.itemMediaDTOList;
          this.viewCount = data.data.viewersCount;
          this.categoryId = this.allDetails.categoryId;
          if (this.allDetails.categoryId) {
            this.getSalesListing();
          }
          if (data.data.itemCutPriceInfoDTO) {
            this.finalPainAmountCut = true;
          }
          this.$store.commit("PRODUCTDETAIL", data.data);
        });
    },
    getSalesListing() {
      this.categoryId = this.allDetails.categoryId;
      const obj = {
        categoryId: this.allDetails.categoryId,
        pageIndex: 0,
        saleType: "NORMAL"
      };
      this.$store
        .dispatch({
          type: "getSalesListing",
          payload: obj
        })
        .then(data => {
          this.recommendedProductList = data.data.saleProductDTOs;
        });
    },
    getComments() {
      this.$store
        .dispatch({
          type: "getCommentsBySale",
          payload: this.$route.params.saleReferenceID,
          limit: this.commentLimit,
          index: this.commentIndex
        })
        .then(data => {
          if (data.data.commentDTOs) {
            this.commentList = data.data.commentDTOs;
            this.$store.commit("commentList", {
              commentsData: this.commentList,
              commentIndex: this.commentIndex + 1
            });
          }
        })
        .catch(err => {
          console.log(err);
          // let obj = {
          //   status: "Failure",
          //   timeoutMs: "5000"
          // };
          // bus.$emit("apiStatus", obj);
        });
    }
  },
  updated() {
    if (!this.$data.saleReferenceID == this.$route.params.saleReferenceID) {
      this.getProductDetail();
    }
  },
  mounted() {
    this.$store.commit("savePreOrderDetail", {
      availablePreOrderData: null
    });

    let [, , id] = window.location.pathname.split("/");
    let [, , saleRef] = this.$route.path.split("/");
    if (id) {
      if (window.location.pathname === `/dukaan/${id}/`) {
        // this.$store.dispatch(`https://groupbuybe.payboard.in/api/v1/users/qr/${id}/details`)
        this.$store
          .dispatch({
            type: "getDukaanQrUsers",
            payload: id
          })
          .then(data => {
            var xauthid = btoa(this.$cookie.get("X-Auth-Id"));
            if (data.data.userId) {
              window.location.href = `http://dukaan.money91.com/#/product-detail/${data.data.userId}/${saleRef}`;
            }
          })
          .catch(err => {
            if (err) console.log("=-=err-=-", err);
            // window.location.href = `https://www.mall91.com/#/detail/${saleRef}`;
          });
      }
    }
    this.getProductDetail();
    this.getComments();
    let header = document.querySelector(".request_header");
    let activeDetailTab = document.querySelector(".detail_tab_name");
    let activeCommentTab = document.querySelector(".comment_tab_name");
    let activeRelatedTab = document.querySelector(".related_prdt_name");
    let detailSection =
      document.getElementById("div-detailtab").clientHeight + 318.4;
    let commentSection =
      document.getElementById("div-comment").clientHeight +
      detailSection +
      318.4;
    let totalHeight = Math.floor(detailSection + commentSection);
    window.onscroll = function() {
      scrollFunction();
    };
    function scrollFunction() {
      if (
        document.body.scrollTop > 218.4 ||
        document.documentElement.scrollTop > 218.4
      ) {
        header.classList.add("sticky");
        activeDetailTab.classList.add("detailactive");
      } else {
        header.classList.remove("sticky");
        activeDetailTab.classList.remove("detailactive");
      }
      if (
        document.body.scrollTop > detailSection ||
        document.documentElement.scrollTop > detailSection
      ) {
        activeDetailTab.classList.remove("detailactive");
        activeCommentTab.classList.add("commentactive");
        activeRelatedTab.classList.remove("relatedprdtactive");
      } else {
        activeCommentTab.classList.remove("commentactive");
      }
      if (
        document.body.scrollTop > commentSection ||
        document.documentElement.scrollTop > commentSection
      ) {
        activeDetailTab.classList.remove("detailactive");
        activeCommentTab.classList.remove("commentactive");
        activeRelatedTab.classList.add("relatedprdtactive");
      } else {
        activeRelatedTab.classList.remove("relatedprdtactive");
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  watch: {
    "$route.params.saleReferenceID": function(id) {
      // this.getProductDetail()
    }
  }
};
</script>